import { A, AnchorProps } from './A';

export const Phone = (props: AnchorProps): React.ReactElement<any, any> | null => {
    return <A {...props} icon="telephone" prefix="tel" />;
};
